import React from 'react';
import PasswordChangeForm from '../../@jumbo/components/Common/authComponents/PasswordChangeForm';

const PasswordChange = () => <PasswordChangeForm variant="standard" wrapperVariant="bgColor" />;

export default PasswordChange;
